/**
 * MODULE: emailTemplateActionDisplay.ts
 * PURPOSE: Shared display helpers for email_template_snapshot context actions (dock, proactive advisor).
 */

import type { AssistantContextAction } from '@shared/lib/frontend/api/assistantContextApi';
import { stripEmailTemplateUsesFromLabel } from './assistantWelcomePrompts';

export type EmailTemplateActionDisplay = {
  displayLabel: string;
  uses?: number;
  recommended: boolean;
  isEmailSnapshot: boolean;
};

function parseUsesFromLabel(label: string): number | undefined {
  const match = label.match(/\(used\s+(\d+)×\)/i);
  if (!match) return undefined;
  const n = Number(match[1]);
  return Number.isFinite(n) && n > 0 ? n : undefined;
}

export function getEmailTemplateActionDisplay(
  action: AssistantContextAction,
): EmailTemplateActionDisplay {
  const label = (action.label || '').trim();
  const isEmailSnapshot = (action.source || '') === 'email_template_snapshot';
  if (!isEmailSnapshot) {
    return { displayLabel: label, recommended: false, isEmailSnapshot: false };
  }
  const uses =
    typeof action.template_uses === 'number' && action.template_uses > 0
      ? action.template_uses
      : parseUsesFromLabel(label);
  return {
    displayLabel: stripEmailTemplateUsesFromLabel(label),
    uses,
    recommended: action.action === 'send_email_template',
    isEmailSnapshot: true,
  };
}
